import { z } from 'my-zod'
import { serviceBulletinsModel } from './service-bulletins-model'

const association = serviceBulletinsModel.shape.vehicleAssociations.element.shape

export const updateServiceBulletinVehicleAssociationSystemRequest = z.object({
  vehicleId: association.vehicleId,
  notes: association.notes,
  state: association.state,
  bulletinId: z.string()
})

export type updateServiceBulletinVehicleAssociationSystemRequest = z.infer<
  typeof updateServiceBulletinVehicleAssociationSystemRequest
>
